import styled from "styled-components";
import {grupoSelected} from '../../redux/actions.js';
import {useDispatch,useSelector} from 'react-redux';
import {Outlet,NavLink,useNavigate,useLocation} from 'react-router-dom'
import {useEffect} from 'react'
import {useParams} from "react-router-dom"
import logofarmasis from "../../imgs/farmasis.png"
import compartir from "../../imgs/compartir.png"
import Chip from '@mui/material/Chip';
import Stack from '@mui/material/Stack';
import Avatar from '@mui/material/Avatar';
import logoCFC from "../../imgs/cfclogo.jpg"
import Buscador from "./buscador.jsx"
import { mobile } from "../../services/services.js"




let DivOpcionGrupo=styled.div`
	
	display:flex;
	justify-content:end;
	margin:5px;
	overflow: auto;
  white-space: nowrap;
	
`

let ReproductorVideos=styled.div`
position:relative
`;


const ContainerBuscador=styled.div` 
	position:absolute;
	left:15px;
	top:4px
`;

export default function Reproductor (props){
	let datos=useSelector(state=>state.data);
	let grupo=useSelector(state=>state.grupo);
	let user=useSelector(state=>state.usuario);
	let location = useLocation();
	let navigate=useNavigate();
	let dispatch=useDispatch();
	let grupos=[];
	let params=useParams();

	useEffect(()=>{
		
	     if(location.pathname==="/Home/tutoriales" ){navigate(`/home/tutoriales/${grupo}`) }
	},[location,grupo,navigate])

  
	
	if(datos.length!==0){ datos.forEach(ele=>grupos.push(Object.keys(ele)[0])) }

  let handleClick=(e)=>{
    let cards=document.getElementsByClassName("card");
    let videos=document.getElementsByClassName("video");
    let descripciones=document.getElementsByClassName("Descrip");
    let icons=document.getElementsByClassName("icon");
   	
   	if(e.target.alt){dispatch(grupoSelected(e.target.alt))} 
   		else{
   				if(!e.target.id){dispatch(grupoSelected(e.target.innerHTML))}
    			else   dispatch(grupoSelected(e.target.id))
   		}
    


    for (let i=0;i<icons.length;i++){
  	       icons[i].src=compartir
	  };

    for (let i=0;i<cards.length;i++){
	       if(cards[i].style.borderColor==="green"){cards[i].style=null}
    };

    for (let i=0;i<videos.length;i++){        
	    			videos[i].pause();
	    			videos[i].controls=false;
	    			videos[i].style=null;
	    			videos[i].setAttribute('poster',logofarmasis)
	   };

    for (let i=0;i<descripciones.length;i++){
	          descripciones[i].style=null;
	  };
  }

	return(
		<ReproductorVideos >
				{params.grupo?
				<ContainerBuscador>
					{mobile()?null:<Buscador/>}
				</ContainerBuscador>:null}
			

				{user==="Administracion"||user==="Cesarin"?
						<DivOpcionGrupo  >
							<Stack direction="row" spacing={1} overflow="auto" >

																		<Chip key={"rutas"}  onClick={handleClick} id={"rutas de implementacion"} to={`./rutas de implementacion`} color="secondary"
																			avatar={<Avatar  alt="MenuRutas" src={logoCFC} />}																				
															 				component={NavLink} label="rutas de implementacion"
															 				variant={grupo==="rutas de implementacion"?"filled":"outlined"}  size="small" clickable/>
								
								{grupos.map(nombre=><Chip key={nombre}  onClick={handleClick} id={nombre} to={`${nombre}`} 
																					color="primary"	 avatar={<Avatar  alt={nombre} src={logoCFC} />}																				
															 				component={NavLink} label={nombre} variant={grupo===nombre?"filled":"outlined"} size="small" clickable/>
																		)}
							</Stack >
						</DivOpcionGrupo>
				:null}		





		    {user==="Ventas"?
		    		<DivOpcionGrupo >
		    			<Stack direction="row" spacing={1} >		    																
		    				{grupos.map(nombre=> nombre!=="Administracion"?
		    															<Chip key={nombre}  onClick={handleClick} id={nombre} to={`${nombre}`} 
																					color="primary" avatar={<Avatar  alt={nombre} src={logoCFC} />}																				
															 				component={NavLink} label={nombre} variant={grupo===nombre?"filled":"outlined"}  clickable/>

		    					:null )}
		    			</Stack >
		    		</DivOpcionGrupo>
		    :null}






		    {user==="Contabilidad"?
		    		<DivOpcionGrupo  >
		    			<Stack direction="row" spacing={1} >
		    				{grupos.map(nombre=> nombre==="Contabilidad"?
		    															<Chip key={nombre}  onClick={handleClick} id={nombre} to={`${nombre}`} 
																					color="primary"	 avatar={<Avatar  alt={nombre} src={logoCFC} />}																				
															 				component={NavLink} label={nombre} variant={grupo===nombre?"filled":"outlined"}  clickable/>
		    					:null )}
							</Stack >
						</DivOpcionGrupo>
				:null}

			
			
    	<Outlet />

		</ReproductorVideos>
	)
}